import { ReactNode, useMemo } from 'react';
import { FormattedNumber, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { DescriptionList, RowWrapper } from '@/shared/view/DescriptionList';
import { TwoLineCell } from '@/shared/view/TwoLineCell';
import { Icon } from '@src-common/view/components/Icon';

import s from './CurrentChauffeur.module.css';

interface Chauffeur {
  id: string;
  firstName: string;
  lastName: string;
  rating?: number;
}

const CurrentChauffeur = ({ chauffeur }: { chauffeur: Chauffeur }) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<['chauffeur', ReactNode, RowWrapper]> => [
      [
        'chauffeur',
        <TwoLineCell
          key="chauffeur"
          line1={[chauffeur.firstName, chauffeur.lastName].join(' ')}
          line2={
            chauffeur.rating ? (
              <FormattedNumber
                value={chauffeur.rating}
                maximumFractionDigits={2}
                minimumFractionDigits={2}
              />
            ) : null
          }
        />,
        ({ children }) => <Link to={`/chauffeurs/${chauffeur.id}`}>{children}</Link>,
      ],
    ],
    [chauffeur],
  );

  const values = {
    chauffeur: () => (
      <div className={s.iconWrapper}>
        <Icon icon={'chevron-to-end'} />,
      </div>
    ),
  };

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Current chauffeur',
        id: 'yVrSEB',
        description: 'Vehicle screen: Current chauffeur section title',
      })}
      titles={titles}
      values={values}
    />
  );
};

export { CurrentChauffeur };
